//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import response from "apis/Response/response"
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function Create(props) {
  const { state, dispatch } = useContext(Context);

  const { createResponse } = response();
  const history = useHistory();
  const classes = styles();
  
  const [states, setstates] = useState({
    statusCode: "",
    type: "",
    message: "",
    keyword:"",
    loading: false,
  });

  const {
    statusCode,
    type,
    message,
    keyword,
    loading,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "RESPONSE", "CREATE"],
    });
  }, []);
  
  // create api func
  const handleCreateResponse = async () => {
    try {
      if (
        !statusCode ||
        !type ||
        !message ||
        !keyword 

      ) {
        toast.error("Please fill all the fields", {
          toastId: "required-fields-error",
        });
        setStates({ loading: false });
        return;
      }
      let values;
      values = {
        statusCode,
        type,
        message,
        keyword
      };
      let res = await createResponse(values);
      if (res && res?.type === "SUCCESS") {
        toast.success("Created", { toastId: "rule-created" });
        history.goBack();
      }
      if (res && res?.type === "ERROR") {
        toast.error("Response Already Exists", {
          toastId: "response-exists",
        });
      }
      setStates({ loading: false });
    } 
    catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18, fontWeight: "bold" }}>{'Create'}</span>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: 10 }}>
        <Grid item xs={3}>
          <CssTextField
            label={"Status Code"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={statusCode}
            onChange={(e) => {
              setStates({ statusCode: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            label={"Type"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={type}
            onChange={(e) => {
              setStates({ type: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            label={"message"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={message}
            onChange={(e) => {
              setStates({ message: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={3}>
        <CssTextField
            label={"keyword"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={keyword}
            onChange={(e) => {
              setStates({ keyword: e.target.value });
            }}
          />
        
        </Grid>
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button
            className={classes.submitBtn}
            onClick={() => {
              setStates({ loading: true });
              handleCreateResponse();
            }}
            disabled={loading}
          >
            {'Submit'}
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
